import React, { Component } from "react";
import { connect } from "react-redux";

import DrawersListComponent from "./DrawersListComponent";
import { setDrawerIframe, closeDrawerIframe } from "Actions";

export class DrawersList extends Component {
  componentDidMount() {
    const { blocs, setDrawerIframe } = this.props;

    if (!blocs || blocs.length === 0) {
      closeDrawerIframe();
      setDrawerIframe("");
      return null;
    }
    setDrawerIframe({ url: blocs[0].url, appType: blocs[0].app });
  }
  render() {
    const { community, isOpen, blocs, apps } = this.props;
    //TODO decommenter ceci
    if (!blocs || blocs.length < 2) {
      return null;
    }

    return (
      <DrawersListComponent
        drawers={blocs}
        community={community}
        isOpen={isOpen}
        apps={apps}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  isOpen: state.params.drawerIframe.isOpen
});

const mapDispatchToProps = dispatch => ({
  setDrawerIframe: options => dispatch(setDrawerIframe(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DrawersList);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/DrawersList/index.js